/**
 * Transform form data into an object
 */
export default {
  computed: {
    ajaxDataType: () => 'json',
    ajaxContentType: () => 'application/json; charset=utf-8'
  },
  methods: {
    async serializeData() {
      let data = {}
      this.form.serializeArray().forEach((item) => {
        data[item.name] = item.value.trim()
      })
      return data
    }
  }
}
